// SHA-256 over audio bytes. Produces the canonical `storageKey` for a
// sample — the content-address that makes dedup, cache-forever, and
// cloud upload short-circuits all work.
//
// Lowercase hex (64 chars) is the stable wire format — same output in
// node tests (via Web Crypto from Node 20+), browser runtime, and
// edge functions. Never change the case.

const HEX = '0123456789abcdef';

export async function sha256Hex(data: ArrayBuffer | Uint8Array): Promise<string> {
  // Copy into a fresh ArrayBuffer so crypto.subtle.digest never sees a
  // SharedArrayBuffer (which modern lib types reject). The copy is cheap
  // compared to the digest itself.
  const view = data instanceof Uint8Array ? data : new Uint8Array(data);
  const buf = new ArrayBuffer(view.byteLength);
  new Uint8Array(buf).set(view);
  const digest = await crypto.subtle.digest('SHA-256', buf);
  return bytesToHex(new Uint8Array(digest));
}

export function bytesToHex(bytes: Uint8Array): string {
  // Faster than Array.from + map for hot paths (small but non-zero win
  // when hashing many samples during a pack import).
  let out = '';
  for (let i = 0; i < bytes.length; i++) {
    const b = bytes[i]!;
    out += HEX[b >>> 4]! + HEX[b & 0x0f]!;
  }
  return out;
}
